module.exports = __webpack_public_path__ + "img/amsbannner4.b303a3d9.png";